var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3213_21077)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#00A239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 37L42 59L32 49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3213_21077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox-icon.35a35bc45607e8eb90e20eda555eb7ce.svg";
export { ForwardRef as ReactComponent };